// post
import {axios} from '../utills/request'

export function postAction (url, parameter) {
  return axios({
    url: url,
    method: 'post',
    data: parameter
  })
}

// get
export function getAction (url, parameter) {
  return axios({
    url: url,
    method: 'get',
    params: parameter
  })
}



// WEBPACK FOOTER //
// ./src/network/GetAndPost.js